module.exports = __webpack_public_path__ + "img/01_pleno.1418693a.png";